import { API_ORIGIN } from "./apiOrigin";
// Phase 43.56 — Lightweight analytics tracker
// Best-effort: non blocca mai l'UX. Errori solo in console.warn.
import { api } from "@/lib/api";
import axios from "axios";

export async function trackEvent(event, metadata = {}) {
  try {
    await api.post("/analytics/events", { event, metadata });
  } catch (e) {
    // Silent: analytics non deve mai bloccare l'utente
    if (typeof window !== "undefined" && window.console) {
      // eslint-disable-next-line no-console
      console.warn(`[analytics] event=${event} failed:`, e?.message || e);
    }
  }
}

// Phase 44.06 — Tracker pubblico (no-auth) per eventi pre-signup
// (es. /track/{token}). Whitelist server-side molto stretta.
export async function trackPublicEvent(event, metadata = {}) {
  try {
    const API = `${API_ORIGIN}/api`;
    await axios.post(`${API}/public/analytics/events`, { event, metadata });
  } catch (e) {
    if (typeof window !== "undefined" && window.console) {
      // eslint-disable-next-line no-console
      console.warn(`[analytics-public] event=${event} failed:`, e?.message || e);
    }
  }
}
